export default {
	lastTouchTime: undefined,
	timeInterval: 2000,
	setTimeInterval: function(timeInterval){
		this.timeInterval = timeInterval;
		return this;
	},
	checkDoubleClick: function(customTimeInterval) {
		var timeInterval = customTimeInterval;
		if(!timeInterval || timeInterval == 0) {
			timeInterval = this.timeInterval;
		}
		if(this.lastTouchTime) {
			let nowTime = new Date().getTime();
			let lastTime = this.lastTouchTime;
			if((nowTime - lastTime) > timeInterval) {
				// 超出了时间间隔
				this.lastTouchTime = nowTime;
				return true;
			} else {
				// 没超过时间间隔
				return false;
			}
			
		}else {
			this.lastTouchTime = new Date().getTime();
			return true;
		}
	}
}